/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_Vibe_SubjectInputs */

const en_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vibe / Subject`)
};

const es_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Ambiente / Sujeto`)
};

const fr_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Ambiance / Le Sujet`)
};

const de_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Stimmung / Das Thema`)
};

const ja_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雰囲気 / 主題`)
};

const zh_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氛围 / 主题`)
};

const ar_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأجواء / الموضوع`)
};

const id_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suasana / Subjek`)
};

const it_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Atmosfera / Il Soggetto`)
};

const ru_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Атмосфера / Тематика`)
};

const pt_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Ambiente / Assunto`)
};

const ko_the_vibe_subject = /** @type {(inputs: The_Vibe_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분위기 / 주제`)
};

/**
* | output |
* | --- |
* | "The Vibe / Subject" |
*
* @param {The_Vibe_SubjectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_vibe_subject = /** @type {((inputs?: The_Vibe_SubjectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_Vibe_SubjectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_vibe_subject(inputs)
	if (locale === "es") return es_the_vibe_subject(inputs)
	if (locale === "fr") return fr_the_vibe_subject(inputs)
	if (locale === "de") return de_the_vibe_subject(inputs)
	if (locale === "ja") return ja_the_vibe_subject(inputs)
	if (locale === "zh") return zh_the_vibe_subject(inputs)
	if (locale === "ar") return ar_the_vibe_subject(inputs)
	if (locale === "id") return id_the_vibe_subject(inputs)
	if (locale === "it") return it_the_vibe_subject(inputs)
	if (locale === "ru") return ru_the_vibe_subject(inputs)
	if (locale === "pt") return pt_the_vibe_subject(inputs)
	return ko_the_vibe_subject(inputs)
});